// The runtime's own words: the relative age a stamp prints (DS #79). His only relative-time line is
// "Held by Marcus Bell · 2 days ago"; a shorter age prints the time or the date instead (lib/time.ts).

import { template } from "../labels";

export const TIME_TEMPLATES = {
  daysAgo: /* @__PURE__ */ template({ text: "{n} days ago" }),
} as const;
